<script setup lang="ts">
import { condoLinks } from '~~/data/links/regionLinks';

import { Container } from '~/components/Container';
</script>

<template>
	<Container class="bg-white-dark-2">
		<div class="flex flex-col gap-6 lg:gap-10">
			<h4
				class="font-matter-sq text-2xl font-normal tracking-[-0.03rem] text-primary md:pb-2 md:text-[32px] md:tracking-[-0.035rem]"
			>
				Descubra outros imóveis em Jardim Europa e arredores
			</h4>

			<NavigationSectionNavigation
				class="justify-start !py-0"
				:card="null"
				:items="condoLinks"
				color="primary"
				links-container-variant="default"
				links-title-classes="hidden"
			/>
		</div>
	</Container>
</template>
